module.exports = __webpack_public_path__ + "img/zoomed-Manufacturers-withwords.19b3a52b.png";